const IMAGES = {
  logo: require('./rinexusgames-logo.png'),
  raft: require('./stranded-on-a-raft.png'),
  rinexus: require('./rinexus-thumbnail.png'),
  sticker1: require('./sticker1.png'),
  sticker2: require('./sticker2.png'),
  game1: require('./game-thumbnail-1.png'),
  game2: require('./game-thumbnail-2.png'),
  game3: require('./game-thumbnail-3.png'),
  game4: require('./game-thumbnail-4.png'),
  raftLogo: require('./new_Raft_logo_outlines.png'),
};

export default IMAGES;